import { getDefaultCondition, searchAuthors, searchCategories, searchPosts, searchPostsOrPage, searchProductCategories, searchProducts, searchProductTags, searchTags, searchTaxonomies } from "./helper";
import { ThemeBuilderSelect, ThemeBuilderSelectSearch } from "jkit-core/control";


export default function ControlManager({ id, fields, values, updateValue, fieldsList }) {
    const isVisible = evaluateDependency(fields.dependency, values, fieldsList);
    if (!isVisible) return null;


    const ApiCall = {
        searchPostsOrPage,
        searchAuthors,
        searchTaxonomies,
        searchCategories,
        searchTags,
        searchPosts,
        searchProductCategories,
        searchProductTags,
        searchProducts
    }

    switch (fields.type) {
        case "select":
            return (
                <ThemeBuilderSelect
                    id={id}
                    label={fields.title}
                    description={fields.description}
                    value={values[id] || fields.default}
                    choices={fields.options}
                    multiple={false}
                    updateValue={updateValue} />
            );

        case "select-search":
            return (
                <ThemeBuilderSelectSearch
                    id={id}
                    value={values[id]}
                    label={fields.title}
                    description={fields.description}
                    onSearch={ApiCall[fields.onSearch] ? ApiCall[fields.onSearch] : []}
                    updateValue={updateValue}
                    multiple={fields.multiple || 0}
                    inputKey={`${fields.id}_${id}`}

                />
            );

        default:
            return null;
    }
};

function evaluateDependency(dependency = [], values, fieldsList) {
    return dependency.every(dep => {
        const actual = values[dep.field] || getDefaultCondition(dep.field, fieldsList);
        switch (dep.operator) {
            case '===':
                return actual === dep.value;
            case '!==':
                return actual !== dep.value;
            case 'in':
                return Array.isArray(dep.value) && dep.value.includes(actual);
            case 'not in':
                return Array.isArray(dep.value) && !dep.value.includes(actual);
            default:
                return true;
        }
    });
}

